export default __webpack_public_path__ + "static/media/beep.7914ab1c.wav";